import React from 'react';

const CustomToggle = React.forwardRef(({ children, onClick, show }, ref) => (
  <i
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className={show}
  >
    { children }
  </i>
));

export default CustomToggle;
